module.exports = __webpack_public_path__ + "img/crypto.06a38751.svg";